/* Landpark Ingwer Shot – Sticky-Button
   Zeigt den Button erst, nachdem die erste Produkt-Section nach oben verlassen wurde,
   und blendet ihn aus, solange irgendeine Produkt-Section im Bild ist. */
(function () {
  function init() {
    var el = document.querySelector('[data-lpg-sticky]');
    if (!el || el.dataset.lpgReady === '1' || !('IntersectionObserver' in window)) return;
    el.dataset.lpgReady = '1';

    var ids = (el.dataset.watch || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var targets = ids.map(function (id) { return document.getElementById(id); }).filter(Boolean);
    if (!targets.length) return;

    var first = targets[0];
    var pastFirst = false;
    var visible = new Set();

    function update() {
      var show = pastFirst && visible.size === 0;
      el.classList.toggle('is-visible', show);
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          visible.add(entry.target);
        } else {
          visible.delete(entry.target);
        }
        if (entry.target === first) {
          pastFirst = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        }
      });
      update();
    }, { rootMargin: '-80px 0px -120px 0px' });

    targets.forEach(function (t) { observer.observe(t); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
